import { InfoTitleProps } from './InfoTitle.types';
import * as Styled from './InfoTitle.styled';
import withDefaultProps from '../../hoc/withDefaultProps';
import withStringOrComponent from '../../hoc/withStringOrComponent';
import { useTheme } from 'styled-components';

import Text from '../Text/Text';
import List from '../List/List';

const InfoTitle = (props: InfoTitleProps) => {
  const {
    link,
    media,
    reverse = false,
    className,
    headingColor,
    subHeadingColor,
  } = props;
  const theme = useTheme();
  const heading = withStringOrComponent(props.heading, InfoTitle.Heading);
  const subHeading = Array.isArray(props.subHeading) ? (
    <InfoTitle.List>{props.subHeading}</InfoTitle.List>
  ) : (
    withStringOrComponent(props.subHeading, InfoTitle.SubHeading)
  );
  const headingColorValue = headingColor
    ? headingColor
    : theme.brand.secondary.darker;
  const subHeadingColorValue = subHeadingColor
    ? subHeadingColor
    : theme.brand.secondary.dark;

  return (
    <Styled.InfoTitle className={className}>
      {media && <Styled.Icon>{media}</Styled.Icon>}
      <Styled.Content>
        <Styled.Heading color={headingColorValue} reverse={reverse}>
          {heading}
        </Styled.Heading>
        {!!subHeading && (
          <Styled.SubHeading color={subHeadingColorValue}>
            {subHeading}
          </Styled.SubHeading>
        )}
        {/* TODO: Add link component link we do with heading and list when we build the nav link component */}
        {link && <div>{link}</div>}{' '}
      </Styled.Content>
    </Styled.InfoTitle>
  );
};

InfoTitle.Heading = withDefaultProps(Text, {
  size: 'l',
  lineHeight: 'm',
  color: 'inherit',
  weight: 'bold',
});

InfoTitle.SubHeading = withDefaultProps(Text, {
  size: 's',
  lineHeight: 'm',
  color: 'inherit',
  weight: 'regular',
});

InfoTitle.List = withDefaultProps(List, {
  divider: '',
});

export default InfoTitle;
